import { render, staticRenderFns } from "./StatsGlobal.vue?vue&type=template&id=4ade8cfc&scoped=true&"
import script from "./StatsGlobal.vue?vue&type=script&lang=js&"
export * from "./StatsGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade8cfc",
  null
  
)

export default component.exports